<template>
    <div  v-show="!isLoading">
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <a href="#" role="button" class="router-link-active" @click.prevent.stop="openAlertModal()">TOPへ</a>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{upperButtonName}}</p>
                    <p class="menu_center_tex_l">{{lowerButtonName}}</p>
                </div>
                <div class="menu_right">
                </div>
            </div>
        </div>
        <div class="main_unit">
            <div class="top_unit">
                <div class="top_right_box_mgt">プレビュー表示 </div>
            </div>
            <div class="tenpo_check_menu">
                <ul>
                    <li v-for="menu in dailyCheckButtonList" :key="menu.daily_check_button_id" :class="dailyCheckButtonLength" >
                        <div v-if="menu.dailyCheckButtonNo === 99">
                            <a href="#" role="button" :class="monthlyClass" @click.prevent.stop="openAlertModal()">
                                {{menu.dailyCheckButtonName}}
                            </a>
                        </div>
                        <div v-else>
                            <a href="#" role="button" :class="classList['classType'][menu.dailyCheckButtonNo-1]" @click.prevent.stop="openAlertModal()">
                                {{menu.dailyCheckButtonName}}
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <AlertDialog :display="showModal.alertDisplay" @close="closeAlertModal"/>
    </div>
</template>

<script>
    import AlertDialog from '@/app/components/common/AlertDialog.vue'

    export default {
        name: 'dailyCheckMenuIndexPreview',
        props: {
            menuId :Number
        },
        components: {
            AlertDialog
        },
        computed: {
            brandId () {
                return this.$store.getters['brand/id'];
            },
            buttonId () {
                return Number(this.$store.getters['checkPage/id'])
            },
            viewType () {
                return this.$store.getters['checkPage/viewType']
            },
            dailyCheckButtonName () {
                return this.$store.getters['preview/dailyCheckButtonName'];
            },
            displayFlg () {
                return this.$store.getters['preview/displayFlg'];
            },
            dailyCheckButtonLength: function () {
                return this.dailyCheckButtonList.length === 7 ? 'col-3':'col-4';
            },
        },
        data() {
            return {
                classList: {
                    classType: [
                        'tenpo_bg01',
                        'tenpo_bg02',
                        'tenpo_bg03',
                        'tenpo_bg04',
                        'tenpo_bg05',
                        'tenpo_bg06',
                    ]
                },
                monthlyClass: 'tenpo_bg99',
                dailyCheckButtonList: [],
                upperButtonName: "",
                lowerButtonName: "",
                showModal: {
                    alertDisplay:false
                },
                isLoading: true
            }
        },
        mounted () {
            let datetime = this.dateFormat();
            this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/', {params: {datetime: datetime}})
                .then(response => {
                    if (this.viewType === 'day1') {
                        this.dailyCheckButtonList = response.data.dailyCheckButtonSettings1;
                    } else if (this.viewType === 'day2') {
                        this.dailyCheckButtonList = response.data.dailyCheckButtonSettings2;
                    }
                    this.upperButtonName = response.data.topButtonSettings.find(list => list.topButtonId === this.menuId).upperButtonName;
                    this.lowerButtonName = response.data.topButtonSettings.find(list => list.topButtonId === this.menuId).lowerButtonName;
                    let inputButton = this.dailyCheckButtonList.find(list => list.dailyCheckButtonId === this.buttonId);
                    inputButton.dailyCheckButtonName = this.dailyCheckButtonName;
                    inputButton.displayFlg = this.displayFlg;
                    this.dailyCheckButtonList = this.dailyCheckButtonList.filter(list => list.displayFlg === 1);
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: ''}
                        },
                        canBack: false
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        methods: {
            dateFormat() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth() + 1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g, year);
                format_str = format_str.replace(/MM/g, month);
                format_str = format_str.replace(/DD/g, day);
                format_str = format_str.replace(/hh/g, hours);
                format_str = format_str.replace(/mm/g, minutes);
                format_str = format_str.replace(/ss/g, seconds);
                return format_str;
            },
            openAlertModal() {
                this.showModal.alertDisplay = true;
            },
            closeAlertModal() {
                this.showModal.alertDisplay = false;
            }
        }
    }
</script>
